import {Component, inject} from '@angular/core';
import {Order} from "../../model/order";
import {OrderSummaryComponent} from "../order-summary/order-summary.component";
import {HttpClient} from "@angular/common/http";
import {NgForOf} from "@angular/common";
import {environment} from "../../../environments/environment";
import {FormsModule} from "@angular/forms";
import {CdkDrag, CdkDragDrop, CdkDropList, transferArrayItem} from "@angular/cdk/drag-drop";
import {OrderService} from "../../service/order.service";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {MatDialog} from "@angular/material/dialog";
import {
  InternalOrderFormComponent
} from "../../actions/internal-order-form/internal-order-form.component";

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [
    OrderSummaryComponent,
    NgForOf,
    FormsModule,
    CdkDropList,
    MatCheckbox,
    MatIcon,
    MatTooltip,
    CdkDrag
  ],
  templateUrl: 'orders-page.component.html',
  styleUrl: './orders-page.component.css'
})
export class OrdersPageComponent {

  private readonly ORDER_FORM_WIDTH = '80%';

  private orderService = inject(OrderService);
  private dialog = inject(MatDialog);

  constructor(private http : HttpClient) {
    this.getOrders();
  }

  createOrder() {
    const dialogRef = this.dialog.open(InternalOrderFormComponent, {
      width: this.ORDER_FORM_WIDTH
    });

    dialogRef.afterClosed().subscribe(() => {
      this.resetOrders();
    });
  }

  ORDER_STATUSES = [
    {status: 'READY', ordersList: new Array<Order>(), label: 'Ready'},
    {status: 'IN_PROCESS', ordersList: new Array<Order>(), label: 'In Process'},
    {status: 'BLX_IDENTIFIER_UPLOAD', ordersList: new Array<Order>(), label: 'BLX Identifier Upload'},
    {status: 'EXCEPTIONS', ordersList: new Array<Order>(), label: 'Exceptions'},
    {status: 'BILLING_ACTIONS', ordersList: new Array<Order>(), label: 'Billing Actions'},
    {status: 'RESOLVED', ordersList: new Array<Order>(), label: 'Resolved'},
    {status: 'CLOSED', ordersList: new Array<Order>(), label: 'Closed'}
  ];

  filterText: string = '';
  filterClosed: boolean = true;
  isLoadingOrders: boolean = false;

  toggleFilter() {
    this.filterClosed = !this.filterClosed;
    this.resetOrders();
  }

  getOrders() {
    this.isLoadingOrders = true;
    this.http.get<Order[]>(environment.apiUrlPrefix + 'orders', {params: {filterClosed: this.filterClosed}}).subscribe(data => {
      data.forEach(currentValue => {
        const status = this.ORDER_STATUSES.find(orderStatus =>
          orderStatus.status === currentValue.status);

        if (status) {
          status.ordersList.push(currentValue);
        } else {
          const readyStatus = this.ORDER_STATUSES.find(orderStatus =>
            orderStatus.status === "READY");
          readyStatus?.ordersList.push(currentValue);
        }
      });
      this.isLoadingOrders = false;
    })
  }

  filterOrders(orders: Order[]) : Order[] {
    if (this.filterText.length > 0) {
      return orders.filter(order => {
        return order.companyName?.toUpperCase().includes(this.filterText.toUpperCase()) ||
          this.filterText === order.orderId.toString() ||
          order.imeiInfo?.some(imeiInfo => {
            return imeiInfo.imei === this.filterText;
          }) ||
          order.imeis?.some(imei => {
            return imei === this.filterText;
          });
      });
    }

    return orders;
  }

  getOrdersMethod(): any {
    return {
      callGetOrdersMethod: () => {
        this.resetOrders();
      }
    }
  }

  resetOrders(): void {
    this.ORDER_STATUSES.forEach(orderStatus =>
      orderStatus.ordersList = []);
    this.getOrders();
  }

  dropListConnectedTo(status: string) {
    return this.ORDER_STATUSES
      .filter(orderStatus => orderStatus.status !== status)
      .map(orderStatus => orderStatus.status);
  }

  drop(event: CdkDragDrop<Order[]>) {
    if (event.previousContainer !== event.container) {
      const order = event.previousContainer.data[event.previousIndex];
      const orderStatus = event.container.id;

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );

      order.status = orderStatus;
      this.orderService.updateOrder(order.orderId, order).subscribe({
        error: (err) => {
          confirm("Error changing status");
          console.log(err);
          this.resetOrders();
        }
      });
    }
  }
}
